
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wideformatprintercosts",
      function () {
        return require("private-next-pages/wideformatprintercosts/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wideformatprintercosts"])
      });
    }
  